import React from 'react';
import { m } from 'motion/react';
import { useSeoHead } from '../hooks/useSeoHead';
import { getRoutePair, hreflangFor, SITE_URL } from '../seoRoutes';

const PAIR = getRoutePair('gtc');

const GTC = () => {
  useSeoHead({
    title: PAIR.en.title,
    description: PAIR.en.description,
    canonical: `${SITE_URL}${PAIR.en.path}`,
    indexable: PAIR.indexable,
    htmlLang: 'en',
    hreflang: hreflangFor(PAIR),
  });

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl font-display font-bold mb-8 text-pstax-navy">General Terms and Conditions</h1>
          
          <div className="prose prose-lg prose-pstax max-w-none text-pstax-gray">
            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">1. Scope of application</h2>
              <p>The following General Terms and Conditions (GTCs) apply to all business relationships between PSTax Steuerberatung FlexCo and our clients in the version valid at the time the contract is concluded.</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">2. Subject matter of the contract</h2>
              <p>We offer tax consulting services, bookkeeping, start-up consulting, the preparation of tax returns and related services for self-employed individuals and companies in Austria.</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">3. Professional standards</h2>
              <p>Our activities are carried out in accordance with the professional standards for tax consultants and auditors in Austria (AAB of KSW). The "General Conditions of Contract for the Public Accounting Professions" (AAB) in their current version form an integral part of our contractual relationship.</p>
              <div className="mt-4">
                <a href="https://old.ksw.or.at/PortalData/1/Resources/aab/AAB_2018_de.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-pstax-blue font-bold hover:underline">
                  Download General Conditions of Contract (AAB) PDF
                </a>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">4. Digital methods</h2>
              <p>PSTax is a digital-first tax firm. The customer agrees to use digital communication channels and tools provided for document exchange and collaboration unless otherwise agreed in writing.</p>
            </section>

            <section className="mb-12 text-sm italic">
              <p>Note: This is a simplified English version of our terms. The legally binding version is the German version and the professional AAB (Allgemeine Auftragsbedingungen) as issued by the Chamber of Tax Consultants and Auditors.</p>
            </section>
          </div>
        </m.div>
      </div>
    </div>
  );
};

export default GTC;
